<template>
  <div class="flex  flex-wrap md:justify-content-end gap-2 pb-2 md:px-3">
    <!-- <Button label="Set my availability" class="teal-button-transparent-small" @click="$emit('set-availability')" /> -->
    <Button label="Schedule a class" class="teal-button-small schedule-class-btn" @click="$emit('schedule-class')" />
  </div>
  <div class="calendar-container-tutor">
    <FullCalendar :options="calendarOptions" />

    <!-- Disclaimer -->
    <div class="text-center w-full max-w-4xl py-4">
      <h3 class="disclaimer-heading text-lg font-semibold mb-2" style="color: #1FC9A3;">Disclaimer</h3>
      <p class="text-700 text-sm m-0 mb-2">
        To access Al features, only platform-approved Al tools may be used.
      </p>
      <p class="text-700 text-sm m-0">
        Unauthorized tools are strictly prohibited.
      </p>
    </div>

  </div>
</template>
<script setup>
import FullCalendar from '@fullcalendar/vue3';
import Button from 'primevue/button';
import { defineEmits, defineProps } from "vue";
defineProps({
  calendarOptions: Object,
  default: () => ({})
});
defineEmits(['set-availability'],['schedule-class']);


</script>
<style scoped>
.calendar-container-tutor {
  width: 100%;
  height: auto;
}
.fc-timegrid-slot {
    height: 120px !important;
  }

.fc-col-header-cell-cushion {
  font-weight: 400;
  text-align: center;
  padding: 6px 0;
  font-size: 14px;
  font-family: Poppins;
}

.fc-toolbar-title {
  font-weight: 400;
  font-size: 17px !important;
  font-family: Poppins;
}

.fc-button-primary {
  background-color: transparent !important;
  border-color: transparent !important;
  color: var(--gray-600) !important;
  font-size: 17px !important;
}

:deep(.fc-timeGridWeek-view .fc-day-today) {
  background-color: var(--teal-50) !important;
}

:deep(.fc-dayGridMonth-view .fc-day-today) {
  background-color: var(--teal-50) !important;
}
:deep(.fc-timeGridDay-view .fc-day-today) {
  background-color: var(--teal-50) !important;
}


@media (max-width: 768px) {
  .fc-timegrid-slot {
    height: 100px !important;
  }
}

.schedule-class-btn {
  margin-top: 12px;
}
</style>